import api from '../callApi';

const saveFormState = (
    recipientEmail,
    widgetActionId,
    actionType,
    widgetId,
    cachedFormData,
    route,
    savedResultData
) => {
    const request = {
        recipientEmail,
        widgetActionId,
        actionType,
        widgetId,
        cachedFormData,
        route
    };

    if (savedResultData) request.savedResultData = savedResultData;

    return api.post('WidgetFormState/Save', request).then(response => {
        return response;
    });
};

export default saveFormState;
